import { FC, ReactElement, useState } from 'react'

import { SignatureModalTemplate } from './templates/SignatureModalTemplate'

export const ModalRequestSignaturesContent: FC<{
  trigger: ReactElement
  contacts: Array<{ name?: string; email: string }>
  onSubmit: (emailMessage: string) => Promise<boolean>
}> = ({ trigger, contacts, onSubmit }) => {
  const [message, setMessage] = useState<string>('')

  return (
    <SignatureModalTemplate
      data-testid="modal.requestSignatures"
      trigger={trigger}
      title="Request signatures"
      onSubmit={() => onSubmit(message)}
      contacts={contacts}
      submitButtonText="Send requests"
    >
      <SignatureModalTemplate.MessageField
        message={message}
        setMessage={setMessage}
        data-testid="modal.requestSignatures.message"
      />
    </SignatureModalTemplate>
  )
}
